// import React, { useState, useEffect } from "react";


// const HospitalDataComponent = ({ data }) => {
//   const [hospitalData, setHospitalData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [expandedHospital, setExpandedHospital] = useState(null);

//   useEffect(() => {
//    // console.log("data", data);
//     // Process data to organize by hospitals and branches
//     const processedData = processHospitalData(data);
//     setHospitalData(processedData);
//     setLoading(false);
//   }, [data]);

//   // Process JSON data to organize by hospitals and branches
//   const processHospitalData = (data) => {
//     const processedHospitals = [];
//     const hospitalMap = new Map();

//     // Extract data from the API response
//     const customer =data//.respData.respMsg.content;

//   if (customer?.doctors && customer?.doctors?.hospitalDoctor) {
//     // customers.forEach((customer) => {
//     customer.doctors.hospitalDoctor.forEach((hospitalDoctor) => {
//       const hospitalInfo = hospitalDoctor.branchId.hospital;
//       const branchInfo = hospitalDoctor.branchId;

//       // Check if hospital already exists in our map
//       if (!hospitalMap.has(hospitalInfo.id)) {
//         hospitalMap.set(hospitalInfo.id, {
//           ...hospitalInfo,
//           branches: [],
//         });
//         processedHospitals.push(hospitalMap.get(hospitalInfo.id));
//       }

//       const hospital = hospitalMap.get(hospitalInfo.id);

//       // Find if branch already exists
//       let branch = hospital.branches.find((b) => b.id === branchInfo.id);

//       if (!branch) {
//         branch = {
//           ...branchInfo,
//           doctors: [],
//         };
//         hospital.branches.push(branch);
//       }

//       // Add doctor information
//       branch.doctors.push({
//         id: customer.doctors.doctorId,
//         name: customer.name,
//         specialization: customer.doctors.specialization,
//         username: hospitalDoctor.username,
//         role: hospitalDoctor.role,
//         hospitalDoctorId: hospitalDoctor.hospitalDoctorID,
//         active: hospitalDoctor.active,
//       });
//     });
//   }
//     // });

//     return processedHospitals;
//   };

//   const toggleHospital = (hospitalId) => {
//     if (expandedHospital === hospitalId) {
//       setExpandedHospital(null);
//     } else {
//       setExpandedHospital(hospitalId);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="container mt-5">
//         <div className="row justify-content-center">
//           <div className="col-md-8 text-center">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-2">Loading hospital data...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div class="modal-dialog modal-dialog-centered">
//       <div className="container mt-4">
//         <div className="row">
//           <div className="col-12">
//             <div className="card shadow-sm">
//               <div className="card-header bg-primary text-white">
//                 <h4 className="mb-0">Hospitals and Doctors</h4>
//               </div>
//               <div className="card-body p-0">
//                 <div className="list-group list-group-flush">
//                   {hospitalData.map((hospital) => (
//                     <div
//                       key={hospital.id}
//                       className="list-group-item px-3 py-3 border-bottom"
//                     >
//                       <div
//                         className="d-flex justify-content-between align-items-center"
//                         onClick={() => toggleHospital(hospital.id)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <div>
//                           <h5 className="mb-1">{hospital.name}</h5>
//                           <p className="mb-0 text-muted">
//                             Location: {hospital.location}
//                           </p>
//                         </div>
//                         <div className="d-flex align-items-center">
//                           <span
//                             className={`badge ${
//                               hospital.active ? "bg-success" : "bg-danger"
//                             } me-2`}
//                           >
//                             {hospital.active ? "Active" : "Inactive"}
//                           </span>
//                           <i
//                             className={`bi ${
//                               expandedHospital === hospital.id
//                                 ? "bi-chevron-up"
//                                 : "bi-chevron-down"
//                             }`}
//                           ></i>
//                         </div>
//                       </div>

//                       {expandedHospital === hospital.id && (
//                         <div className="mt-3">
//                           <h6 className="text-muted mb-3">Branches</h6>

//                           {hospital.branches.map((branch) => (
//                             <div key={branch.id} className="card mb-3">
//                               <div className="card-header d-flex justify-content-between align-items-center py-2">
//                                 <h6 className="mb-0">{branch.branchName}</h6>
//                                 <span
//                                   className={`badge ${
//                                     branch.active ? "bg-success" : "bg-danger"
//                                   }`}
//                                 >
//                                   {branch.active ? "Active" : "Inactive"}
//                                 </span>
//                               </div>
//                               <div className="card-body">
//                                 <p className="card-text">
//                                   Address: {branch.branchAddress}
//                                 </p>

//                                 <div className="mt-3">
//                                   <h6 className="text-primary mb-3">
//                                     Doctors ({branch.doctors.length})
//                                   </h6>

//                                   {branch.doctors.map((doctor) => (
//                                     <div
//                                       key={doctor.id}
//                                       className="card mb-2 bg-light"
//                                     >
//                                       <div className="card-body py-2">
//                                         <div className="d-flex justify-content-between align-items-center mb-2">
//                                           <h6 className="mb-0">
//                                             {doctor.name}
//                                           </h6>
//                                           <span className="badge bg-info">
//                                             {doctor.specialization}
//                                           </span>
//                                         </div>
//                                         <div className="small">
//                                           <p className="mb-1 text-muted">
//                                             Username: {doctor.username}
//                                           </p>
//                                           <p className="mb-1 text-muted">
//                                             Role: {doctor.role}
//                                           </p>
//                                           <p className="mb-0 text-muted">
//                                             Doctor ID: {doctor.id}
//                                           </p>
//                                         </div>
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HospitalDataComponent;

import React, { useState, useEffect } from "react";

const HospitalDataComponent = ({ data, isOpen, onClose }) => {
  const [hospitalData, setHospitalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedHospital, setExpandedHospital] = useState(null);

  useEffect(() => {
    // Process data to organize by hospitals and branches
    if (data) {
      const processedData = processHospitalData(data);
      setHospitalData(processedData);
      setLoading(false);
    }
  }, [data]);

  // Process JSON data to organize by hospitals and branches
  const processHospitalData = (data) => {
    const processedHospitals = [];
    const hospitalMap = new Map();

    // Extract data from the input
    const customer = data;

    if (customer?.doctors && customer?.doctors?.hospitalDoctor) {
      customer.doctors.hospitalDoctor.forEach((hospitalDoctor) => {
        const hospitalInfo = hospitalDoctor.branchId.hospital;
        const branchInfo = hospitalDoctor.branchId;

        // Check if hospital already exists in our map
        if (!hospitalMap.has(hospitalInfo.id)) {
          hospitalMap.set(hospitalInfo.id, {
            ...hospitalInfo,
            branches: [],
          });
          processedHospitals.push(hospitalMap.get(hospitalInfo.id));
        }

        const hospital = hospitalMap.get(hospitalInfo.id);

        // Find if branch already exists
        let branch = hospital.branches.find((b) => b.id === branchInfo.id);

        if (!branch) {
          branch = {
            ...branchInfo,
            doctors: [],
          };
          hospital.branches.push(branch);
        }

        // Add doctor information
        branch.doctors.push({
          id: customer.doctors.doctorId,
          name: customer.name,
          specialization: customer.doctors.specialization,
          username: hospitalDoctor.username,
          role: hospitalDoctor.role,
          hospitalDoctorId: hospitalDoctor.hospitalDoctorID,
          active: hospitalDoctor.active,
        });
      });
    }

    return processedHospitals;
  };

  const toggleHospital = (hospitalId) => {
    setExpandedHospital(expandedHospital === hospitalId ? null : hospitalId);
  };

  // This is the correct approach - don't render anything if modal is not open
  if (!isOpen) {
    return null;
  }

  // Loading content within the proper modal structure
  if (loading) {
    return (
      <>
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center p-5">
                <div
                  className="spinner-border text-primary mx-auto"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading hospital data...</p>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop show"></div>
      </>
    );
  }

  // Main modal content
  return (
    <>
      <div className="modal d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Hospitals and Doctors</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body p-0">
              {hospitalData.length === 0 ? (
                <div className="text-center p-4">
                  <p>No hospital data available.</p>
                </div>
              ) : (
                <div className="list-group list-group-flush">
                  {hospitalData.map((hospital) => (
                    <div
                      key={hospital.id}
                      className="list-group-item px-3 py-3 border-bottom"
                    >
                      <div
                        className="d-flex justify-content-between align-items-center"
                        onClick={() => toggleHospital(hospital.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <div>
                          <h5 className="mb-1">{hospital.name}</h5>
                          <p className="mb-0 text-muted">
                            Location: {hospital.location}
                          </p>
                        </div>
                        <div className="d-flex align-items-center">
                          <span
                            className={`badge ${
                              hospital.active ? "bg-success" : "bg-danger"
                            } me-2`}
                          >
                            {hospital.active ? "Active" : "Inactive"}
                          </span>
                          <i
                            className={`bi ${
                              expandedHospital === hospital.id
                                ? "bi-chevron-up"
                                : "bi-chevron-down"
                            }`}
                          ></i>
                        </div>
                      </div>

                      {expandedHospital === hospital.id && (
                        <div className="mt-3">
                          <h6 className="text-muted mb-3">Branches</h6>

                          {hospital.branches.length > 0 ? (
                            hospital.branches.map((branch) => (
                              <div key={branch.id} className="card mb-3">
                                <div className="card-header d-flex justify-content-between align-items-center py-2 bg-light">
                                  <h6 className="mb-0">{branch.branchName}</h6>
                                  <span
                                    className={`badge ${
                                      branch.active ? "bg-success" : "bg-danger"
                                    }`}
                                  >
                                    {branch.active ? "Active" : "Inactive"}
                                  </span>
                                </div>
                                <div className="card-body">
                                  <p className="card-text">
                                    Address: {branch.branchAddress}
                                  </p>

                                  <div className="mt-3">
                                    <h6 className="text-primary mb-3">
                                      Doctors ({branch.doctors.length})
                                    </h6>

                                    {branch.doctors.length > 0 ? (
                                      <div className="row row-cols-1 row-cols-md-2 g-3">
                                        {branch.doctors.map((doctor) => (
                                          <div key={doctor.id} className="col">
                                            <div className="card h-100 bg-light">
                                              <div className="card-body py-2">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <h6 className="mb-0">
                                                    {doctor.name}
                                                  </h6>
                                                  <span className="badge bg-info">
                                                    {doctor.specialization}
                                                  </span>
                                                </div>
                                                <div className="small">
                                                  <p className="mb-1 text-muted">
                                                    Username: {doctor.username}
                                                  </p>
                                                  <p className="mb-1 text-muted">
                                                    Role: {doctor.role}
                                                  </p>
                                                  <p className="mb-0 text-muted">
                                                    Doctor ID: {doctor.id}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <p>
                                        No doctors available for this branch.
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p>No branches available for this hospital.</p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
    </>
  );
};

export default HospitalDataComponent;